import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppService } from '@app/app.service';
import { takeUntil } from 'rxjs/operators';
import { dialogTemplateType, IDialogConfig } from '../interfaces/dialog.interface';

/** Компонент: основа диалогового окна */
@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['../styles/dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogComponent {
    constructor(public appService: AppService) {}

    /** Заголовок диалогового окна */
    @Input() public title: string;

    /** Событие закрытия диалогового окна */
    @Output() public close = new EventEmitter<{ save: boolean }>();

    /**
     * Динамический диалог
     * @param dialog Диалог для создания
     * @param component Компонент диалога
     * @param config Конфиг диалога
     * @param instanceProcessing - обратный вызов для внешней обработка состояния
     */
    static commonDialog<T, R = any>(
        dialog: MatDialog,
        component: dialogTemplateType<T>,
        config: IDialogConfig,
        instanceProcessing: (...args) => void = null,
    ): MatDialogRef<T, R> {
        const dialogRef = dialog.open(component, DialogComponent._dialogConfigInit(config));

        if (instanceProcessing) {
            instanceProcessing(dialogRef.componentInstance);
        }

        dialogRef
            .keydownEvents()
            .pipe(takeUntil(dialogRef.afterClosed()))
            .subscribe((result) => {
                if (result.code === 'Escape') {
                    dialogRef.close({ result, save: false });
                }
            });
        return dialogRef;
    }

    /**
     * Инициализация диалога с установкой дефолтных параметров
     * @param config
     * @private
     */
    private static _dialogConfigInit(config: IDialogConfig): IDialogConfig {
        const configDialog: IDialogConfig = {
            disableClose: false,
            autoFocus: config?.autoFocus === true,
            data: config.data ?? null,
            maxHeight: config.maxHeight ?? '93vh',
        };
        if (config?.width) {
            configDialog.width = config?.width;
        }

        if (config?.minHeight) {
            configDialog.minHeight = config?.minHeight;
        }

        if (config?.minWidth) {
            configDialog.minWidth = config?.minWidth;
        }

        if (config?.id) {
            configDialog.id = config?.id;
        }

        if (config?.height) {
            configDialog.height = config?.height;
        }

        if (config?.disableClose === true) {
            configDialog.disableClose = true;
        }

        return configDialog;
    }
}
